import get from 'lodash/get';

export const getAssociationWithCollectMembershipNumber = (event) => {
  const associations = get(event, 'Associations', []);
  return (
    associations.find((association) => association.CollectMembershipNumber) ||
    {}
  );
};
